import React, { createContext } from "react"
import { WebAppConfig } from "../web-app-config"

export const ConfigContext = createContext<WebAppConfig>({} as WebAppConfig)

export function useConfig(): WebAppConfig {
    return React.useContext(ConfigContext)
}
